module.exports = __webpack_public_path__ + "ProximaNovaCond-Bold.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/fonts/ProximaNovaCond-Bold.woff
 ** module id = 197
 ** module chunks = 1
 **/